import React, { useState } from "react";
import ReadOnlySlider from "./ReadOnlySlider";

function RuleImportancyRange({ item }) {
  return (
    <>
      <ReadOnlySlider
        label="리드타임"
        value={item.leadtime_level}
        selection={
          item.learning_direction === 0
            ? "Backward"
            : item.learning_direction === 1
            ? "Forward"
            : "Back + Forward"
        }
      />
      <ReadOnlySlider
        label="전체일정"
        value={item.schedule_adherence}
        selection={
          item.learning_direction === 0
            ? "Backward"
            : item.learning_direction === 1
            ? "Forward"
            : "Back + Forward"
        }
      />
      <ReadOnlySlider
        label="납기준수"
        value={item.duedate_compliance}
        selection={
          item.learning_direction === 0
            ? "Backward"
            : item.learning_direction === 1
            ? "Forward"
            : "Back + Forward"
        }
      />
      <ReadOnlySlider
        label="주문 우선순위"
        value={item.order_priority}
        selection={
          item.learning_direction === 0
            ? "Backward"
            : item.learning_direction === 1
            ? "Forward"
            : "Back + Forward"
        }
      />
    </>
  );
}

export default RuleImportancyRange;
